import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default ['$q',
    'JsonRPCService', ($q, JsonRPCService) => {
        const capabilityPrefix = ApplicationFeatures.getAllFeatures().gatewayendorsement === 'true' ? 'gateway' : '';

        return {
            loadRenewal: (jobNumber) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'retrieve', [jobNumber]);
            },

            saveRenewal: (model) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'updateDraftRenewal', [model]);
            },

            setQuoteToDraft: (jobNumber, sessionUUID) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'setQuoteToDraft', [jobNumber, sessionUUID]);
            },

            updateCoverages: (jobNumber, lobCoverages, sessionUUID) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'updateCoverages', [jobNumber, lobCoverages, sessionUUID]);
            },

            generateQuote: (model) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'quote', [model]);
            },

            isQuoted: (jobNumber) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'isQuoted', [jobNumber]);
            },

            retrievePaymentPlans: (jobNumber) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'retrievePaymentPlans', [jobNumber]);
            },

            bind: (model) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'bind', [model]);
            },

            updatePaymentPlan: (model) => {
                return JsonRPCService.send('pc', `${capabilityPrefix}renewal/renewal`, 'updatePaymentPlan', [model]);
            }
        };
    }
];
